import { render } from "./CustomTa3.vue?vue&type=template&id=cf3649cc"
import script from "./CustomTa3.vue?vue&type=script&lang=js"
export * from "./CustomTa3.vue?vue&type=script&lang=js"

import "./CustomTa3.vue?vue&type=style&index=0&id=cf3649cc&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__